module.exports = __webpack_public_path__ + "site/img/266.23a24a41.jpg";